module.exports = __webpack_public_path__ + "img/ivTest_sub56.bec1f726.jpg";